import React, { useEffect, useState } from "react";
import { Button, Modal } from "@material-ui/core";
import ChipInput from "material-ui-chip-input";
import { request } from "../../service/common";
import { useParams } from "react-router";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import MultiSelect from "react-multi-select-component";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import { addAction, getProjectList } from "../../store/project";
import { addPermission, getUserById } from "../../store/user";
import { toast } from "react-toastify";

const UserView = () => {
  const dispatch = useDispatch();

  let { id }: any = useParams();
  const [editProjectName, setEditProjectName] = useState<any>("");

  const [project, setProject] = useState<any>({});
  const [roles, setRoles] = useState<any>([]);
  const [rolesOption, setRolesOptions] = useState<any>([]);
  const [selectedRoles, setSelectedRoles] = useState<any>([]);
  const [openActionModal, setActionModal] = useState(false);
  const [openEditModal, setEditModal] = useState(false);

  const [openRoleModal, setRoleModal] = useState(false);
  const { selectedUser } = useSelector((state: RootState) => state.user);
  const { projectList } = useSelector((state: RootState) => state.project);

  const closeActionModal = () => {
    setActionModal(false);
  };
  const closeEditModal = () => {
    setEditModal(false);
  };
  const OpenActionModal = () => {
    let rolesArr: any = [];
    if (roles.length > 0) {
      roles.map((role: any) => {
        rolesArr.push({ label: role, value: role });
      });
    }
    setRolesOptions(rolesArr);
    setActionModal(true);
  };
  const closeRoleModal = () => {
    setRoleModal(false);
  };

  useEffect(() => {
    getUser();
  }, []);

  const getUser = async () => {
    dispatch(getUserById(id));
    dispatch(getProjectList({ search: "", page: 1, limit: 100 }));
  };

  const actionSchema = yup.object().shape({
    project_id: yup.string().required("project is required!"),
    roles: yup.string().required("Roles is required!"),
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(actionSchema),
    defaultValues: {
      project_id: "",
      roles: "",
    },
  });
  const actionSubmit = async (data: any) => {
let from_data={...data}
    from_data.roles=[data.roles]
    console.log("data",from_data)

    await dispatch(addPermission({ id: id, data: from_data }));
    toast.success("Permission added successfully", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    closeActionModal();
  };
  const changeProject = async (data: any) => {
    let rolesForselect = projectList.filter(
      (project) => project.name == data.target.value
    );
    if (rolesForselect.length > 0) {
      setRoles(rolesForselect[0].roles);
    }
  };
  const editModalOpen = (data: any) => {
    let rolesForselect = projectList.filter(
      (project) => project.name == data
    );
    if (rolesForselect.length > 0) {
      let rolesArr: any = [];
      rolesForselect[0].roles.map((role: any) => {
        rolesArr.push({ label: role, value: role });
      });
      console.log("rolesArr",rolesArr)

      setRolesOptions(rolesArr);
    }
    if (selectedUser[data]&&selectedUser[data].roles.length > 0) {
      let rolesArr: any = [];
      selectedUser[data].roles.map((role: any) => {
        rolesArr.push({ label: role, value: role });
      });
      console.log("rolesArr",rolesArr)

      setSelectedRoles(rolesArr)
    }
    console.log("selectedUser[data].roles",selectedUser[data].roles)
    setEditProjectName(data)
    setEditModal(true);

  };
  const submitEdit = async() => {
    let rolesArr: any = [];

    if (selectedRoles.length > 0) {
      selectedRoles.map((role: any) => {
        rolesArr.push(role.value);
      });
    }
    console.log(rolesArr.toString())
    let data={
      project_id: editProjectName,
      roles: rolesArr,
    }
    await dispatch(addPermission({ id: id, data: data }));
    toast.success("Permission added successfully", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    closeEditModal();
  };

  return (
    <>
      <table className="table data__table">
        <thead>
          <th>Name</th>
          <th>Value</th>
        </thead>
        <tbody>
          <tr>
            <td>Name</td>
            <td>
              {selectedUser.first_name} {selectedUser.last_name}
            </td>
          </tr>
          <tr>
            <td>Email</td>
            <td>{selectedUser.email}</td>
          </tr>
          <tr>
            <td>Permission</td>
            <td>
              {projectList &&
                projectList.length > 0 &&
                projectList.map((project: any) => {
                  // console.log(selectedUser[project.name]);
                  return (
                    <div className="roll-container">
                      <div className="proj-name">
                        {selectedUser[project.name] ? project.name + " -" : ""}
                      </div>
                      <div className="proj-role">
                        {selectedUser[project.name] &&
                          selectedUser[project.name].roles &&
                          selectedUser[project.name].roles.length > 0 &&
                          selectedUser[project.name].roles.map((role: any, index: number) => {
                            return (
                              <>
                                <span>{role} </span>
                                <span>{(index < (selectedUser[project.name].length - 1)) && ','}</span>
                              </>
                            );
                          })}
                      </div>
                      {selectedUser[project.name] && <div className="proj-action-buttons">
                        <Button
                          type="button"
                          variant="contained"
                          className="btn-sm edit-btn"
                          color="primary"
                          onClick={() => editModalOpen(project.name)}
                        >
                          Edit
                        </Button>

                      </div>}
                    </div>
                  );
                })}
              <Button
                type="button"
                variant="contained"
                className="btn-sm"
                color="primary"
                onClick={OpenActionModal}
              >
                Add Permission
              </Button>
            </td>
          </tr>
        </tbody>
      </table>
      <Modal
        open={openEditModal}
        onClose={closeEditModal}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <div className="card custom-modal">
          <div className="card-header d-flex align-items-center border-bottom ">
            <h2 id="simple-modal-title" className="mb-0">
              Permission on {editProjectName} project
            </h2>
            <button className="btn close_btn" onClick={closeEditModal}>
              <span>&times;</span>
            </button>
          </div>
          <div className="card-body">
            <form onSubmit={submitEdit}>

              <div className="mb-3">
                <label className="form-label">Roles</label>

                <MultiSelect
                  className="custom-select"
                  options={rolesOption}
                  value={selectedRoles}
                  onChange={setSelectedRoles}
                  labelledBy="Roles"
                />
                <p className="error">{errors.roles?.message}</p>
              </div>

              <Button
                className="mt-4"
                variant="contained"
                color="primary"
                type="submit"
              >
                Submit
              </Button>
            </form>
          </div>
        </div>
      </Modal>
      <Modal
        open={openActionModal}
        onClose={closeActionModal}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <div className="card custom-modal">
          <div className="card-header d-flex align-items-center border-bottom ">
            <h2 id="simple-modal-title" className="mb-0">
              Permission on project
            </h2>
            <button className="btn close_btn" onClick={closeActionModal}>
              <span>&times;</span>
            </button>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit(actionSubmit)}>
              <div className="mb-3">
                <label className="form-label">Project Name</label>
                <select
                  className="form-control"
                  {...register("project_id")}
                  onChange={changeProject}
                  placeholder="Select Project"
                >
                  {projectList.map((type: any) => {
                    return <option value={type.name}>{type.name}</option>;
                  })}
                </select>
                <p className="error">{errors.project_id?.message}</p>
              </div>
              <div className="mb-3">
                <label className="form-label">Roles</label>
                <select
                  className="form-control"
                  {...register("roles")}
                  placeholder="Select Roles"
                >
                  {roles &&
                    roles.length > 0 &&
                    roles.map((type: any) => {
                      // console.log(type);
                      return <option value={type}>{type}</option>;
                    })}
                </select>
                <p className="error">{errors.roles?.message}</p>
              </div>

              <Button
                className="mt-4"
                variant="contained"
                color="primary"
                type="submit"
              >
                Submit
              </Button>
            </form>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default UserView;
